var map = {
	"./BT.svg": "l2mP",
	"./FTP.svg": "BHXI",
	"./Icedrive.svg": "QvJf",
	"./NAS.svg": "ia9F",
	"./WEBDE.svg": "QlGI",
	"./aDrive.svg": "lKZ9",
	"./amazon.svg": "V3ny",
	"./amazonS3.svg": "zE+a",
	"./backblaze.svg": "WYOE",
	"./baiDu.svg": "kB5O",
	"./box.svg": "qkNL",
	"./boxBusiness.svg": "WBNi",
	"./cloudMe.svg": "V5/5",
	"./cubby.svg": "ITbx",
	"./dropbox.svg": "l8t8",
	"./dropbox4Business.svg": "h4u8",
	"./egnyte.svg": "vaFB",
	"./evernote.svg": "0syC",
	"./flickr.svg": "aVNP",
	"./fourShared.svg": "72jc",
	"./gSuite.svg": "GWiy",
	"./gSuiteSharedDrive.svg": "/Axd",
	"./gmail.svg": "DPzQ",
	"./googlePhotos.svg": "RpvI",
	"./googlePhotosV2.svg": "1x6t",
	"./google_drive.svg": "R/IE",
	"./google_drive_sharedWithMe.svg": "WaAN",
	"./google_drive_shared_v2.svg": "EN7n",
	"./google_drive_v2.svg": "5W1j",
	"./hiDrive.svg": "KGDt",
	"./hubiC.svg": "gPHY",
	"./iCloudDrive.svg": "wb5z",
	"./iCloudPhotos.svg": "QJwH",
	"./iDrivee2.svg": "Ke33",
	"./link.svg": "avI/",
	"./mediafire.svg": "EVVv",
	"./mega.svg": "u6+8",
	"./myDrive.svg": "tvcl",
	"./mySQL.svg": "bFXY",
	"./officeMail.svg": "l5vN",
	"./oneDrive.svg": "hR3K",
	"./oneDrive4Business.svg": "IwLw",
	"./oneDriveV2.svg": "iT6v",
	"./outlook.svg": "n3L6",
	"./ownCloud.svg": "0i5g",
	"./pCloud.svg": "/32x",
	"./putio.svg": "WeYu",
	"./sharePointOnline.svg": "36Hk",
	"./sugarSync.svg": "pK+t",
	"./undefined.svg": "bqgO",
	"./wasabi.svg": "GOcv",
	"./webDav.svg": "0KXw",
	"./yandex.svg": "qefN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "AOpT";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drive/logo ^\.\/.*\.svg$
// module id = AOpT
// module chunks = 1